import React from 'react';

export default function PushNotificationsForm() {
    return (
        <div>
            {'Push Notification Form'}
        </div>
    );
}
